import cn from 'classnames';
import { IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';

export const IconBasket = (props: IconProps) => (
  <svg className={cn(iconStyles(props))} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 25">
    <g fill="none" fillRule="evenodd">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
        d="M1 1h4.489004l5.280844 18.4 13.3783-.537801"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
        d="M6.555556 4.68H26l-2.041812 9.58472L10.018515 15.72"
      />
      <path d="M11.185185 23.08c0 .507877-.41495.92-.926311.92s-.92554-.412123-.92554-.92c0-.508643.414179-.92.92554-.92.51136 0 .926311.411357.926311.92zM23.222222 23.08c0 .507877-.41418.92-.92554.92-.511361 0-.926312-.412123-.926312-.92 0-.508643.41495-.92.926312-.92.51136 0 .92554.411357.92554.92z" />
    </g>
  </svg>
);
